<template>
  <div class="wrap" style="overflow: hidden">
    <div class="content">
      <yd-preview :buttons="btns" class="nobtn">
        <yd-preview-header>
          <div slot="left" style="color:#000">预约信息</div>
          <div slot="right">
            <yd-badge shape="square" v-if="status=='0'" type="danger">已完成</yd-badge>
            <yd-badge shape="square" v-else-if="status=='1'" type="primary">待处理</yd-badge>
            <yd-badge shape="square" v-else-if="status=='2'" type="square">已取消</yd-badge>
            <yd-badge shape="square" v-else type="warning">已过期</yd-badge>
          </div>
        </yd-preview-header>
        <yd-preview-item>
          <div slot="left">姓名</div>
          <div slot="right">{{name}}</div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">车牌</div>
          <div slot="right">{{carno}}</div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">预约日期</div>
          <div slot="right">{{appointdate}}</div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">预约顺序</div>
          <div slot="right" style="font-size:16px;font-weight:bold;color:#333;">{{sequence}}</div>
        </yd-preview-item>
        <yd-preview-item>
          <div slot="left">预约时间</div>
          <div slot="right">{{period}}</div>
        </yd-preview-item>
      </yd-preview>
      <div>
        <yd-button type="primary" v-if="status=='1'" @click.native="checkCar">核消</yd-button>
        <yd-button type="primary" @click.native="goCheckIndex">返回</yd-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  name: "checkInfo",
  data() {
    return {
      checkUserId: window.localStorage.getItem("checkUserId"),
      btns: [],
      id: "",
      name: "",
      sequence: "",
      carno: "",
      appointdate: "",
      period: "",
      createdtime: "",
      updatedtime: "",
      status: ""
    };
  },
  methods: {
    goCheckIndex() {
      this.$router.push({ path: "/checkIndex" });
    },
    getCheckInfo() {
      if (this.checkUserId == "" || this.checkUserId == undefined) {
        this.$router.push({ path: "/checkLogin" });
        return;
      }
      let queryParams = this.extractQueryParams(window.location.href);
      this.id = queryParams.id;
      axios({
        method: "get",
        url: baseUrl + "appointment?id=" + this.id
      }).then(resp => {
        if (resp.data.error_code == "0") {
          let data = resp.data.data;
          this.id = data.id;
          this.name = data.name;
          this.sequence = data.sequence;
          this.appointdate = data.appointdate;
          this.status = data.status;
          this.carno = data.carno;
          this.period = data.period;
          this.createdtime = data.createdtime;
          this.updatedtime = data.updatedtime;
        } else {
          this.$dialog.toast({ mes: "无法获取预约信息", timeout: 1500 });
        }
      });
    },
    checkCar() {
      this.$dialog.confirm({
        title: '提示',
        mes: '确定核消吗！',
        opts: [
            {
                txt: '取消',
                color: false,
                callback: () => {
                   
                }
            },
            {
                txt: '确定',
                color: true,
                callback: () => {
                  axios({
                    method: "get",
                    url:
                      baseUrl +
                      "check?username=" +
                      this.checkUserId +
                      "&result=1&id=" +
                      this.id
                  }).then(resp => {
                    if (resp.data.error_code == "0") {
                      this.$dialog.toast({ mes: "操作成功", timeout: 1000 });
                      this.$router.push({ path: "/checkList" });
                    } else {
                      this.$dialog.toast({ mes: "操作失败，请稍后再试", timeout: 1500 });
                    }
                  });
                }
            }
        ]
      });
    },
    extractQueryParams(url) {
      let queryParams = {};
      if (url.includes("?")) {
        let queryString = url.substr(url.indexOf("?") + 1);
        let pairs = queryString.split("&");
        for (let pair of pairs) {
          let splitArray = pair.split("=");
          let key = splitArray[0];
          let value = splitArray[1];
          if (value.indexOf("#") > -1) {
            value = value.substring(0, value.indexOf("#"));
          }
          queryParams[key] = value;
        }
      }
      return queryParams;
    }
  },
  mounted() {
    this.getCheckInfo();
  }
};
</script>

<style scoped>
.wrap /deep/ .yd-tab-nav .yd-tab-active {
  color: rgba(47, 111, 255, 1) !important;
}
.yd-preview-header > :first-child {
  color: black;
  font-weight: bold;
  font-size: 16px;
  text-align: left;
}
.wrap /deep/ .yd-preview-footer:before {
  height: 2px;
}
.yd-preview {
  margin-bottom: 10px;
}
.yd-preview-footer {
  height: 0.8rem;
}
.wrap /deep/ .nobtn .yd-preview-footer {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/check-info.vue